import React from 'react';
import OperatorBanner from 'gatsby-core-theme/src/components/atoms/header-operator-bannner';
import Tnc from 'gatsby-core-theme/src/components/molecules/tnc';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import PropTypes from 'prop-types';
import styles from './templateOneTwo.module.scss';
import { TrackingKeys } from '~constants/tracking-api';
import { imagePrettyUrl } from '~helpers/getters';

const TemplateOne = ({ page, relation, moduleName = TrackingKeys?.HEADEROPERATOR }) => {
  const backgroundImage = relation?.extra_fields?.campaign_image;

  const bgcolor = page?.extra_fields?.operator_background_color;

  return (
    <div className={styles.container || ''} style={bgcolor ? { background: bgcolor } : {}}>
      <div className={styles.leftSide}>
        <OperatorBanner
          operator={relation}
          clickedElement="header_operator_banner"
          moduleName={moduleName}
        />
        <Tnc operator={relation} />
      </div>
      <div className={styles.rightSide}>
        <LazyImage
          alt="Background Image"
          loading="eager"
          width={100}
          height={100}
          src={
            backgroundImage
              ? imagePrettyUrl(`${backgroundImage.filename}${backgroundImage.extension}`, 387, 500)
              : '/images/desktopBonusBg.png'
          }
          className={styles.backgroundImage}
        />
        <LazyImage
          alt="Logo"
          loading="eager"
          width={80}
          height={80}
          src={imagePrettyUrl(relation.logo.filename)}
          className={styles.logo}
        />
      </div>
    </div>
  );
};

TemplateOne.propTypes = {
  moduleName: PropTypes.string,
  page: PropTypes.shape({
    extra_fields: PropTypes.shape({
      background_image: PropTypes.string,
      operator_background_color: PropTypes.string,
    }),
  }),
  relation: PropTypes.shape({
    logo: PropTypes.shape({
      filename: PropTypes.string,
    }),
    extra_fields: PropTypes.shape({
      campaign_image: PropTypes.string,
    }),
  }),
};

export default TemplateOne;
